import request from '@/utils/request'

// 查询用户业务模式
export function findUserBusinessTypeStatistics() {
  return request({
    url: `/user_business_type_statistics`,
    method: 'get'
  })
}
